import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Section } from '../Section';
import { MetricCard } from '../MetricCard';
import { Panel } from '../ui/Panel';
import { Pill } from '../ui/Pill';
const comparison = [{
  label: 'Before',
  value: 'Static Figma mockups',
  detail: '2 sign-off cycles · ~1 week per review'
}, {
  label: 'After',
  value: 'Live prototype, real GeoJSON',
  detail: '1 sign-off cycle · decisions in days'
}];
export function Outcome() {
  return <Section number="07" kicker="Impact" title="Sign-off cycles halved" lede="Prototyping in the same software the map was being built in with real data, changed how quickly stakeholders could commit." tone="mist" data-id="element-94" data-mp="3vxc0okjbm68w">
      <div className="grid grid-cols-12 gap-8" data-id="element-95" data-mp="3mw4gf6dn35xt">
        <div className="col-span-5" data-id="element-96" data-mp="3mut3oh27unuk">
          <MetricCard stat={{
          value: '2 → 1',
          label: 'Stakeholder sign-off cycles, turning a week-long review process into a matter of days'
        }} size="lg" data-id="element-97" data-mp="26inrst9xv6fm" />
        </div>

        <div className="col-span-7" data-id="element-98" data-mp="2qw0rmp8wvy2k">
          <Panel padding="lg" data-id="element-99" data-mp="2qx24mz9hmumx">
            <Pill variant="green" data-id="element-100" data-mp="2qyd971arc6f3">Method</Pill>
            <p className="mt-6 font-sans text-[16px] leading-[1.8] text-ink-muted" data-id="element-101" data-mp="2mvgwtsbt96jl">
              I worked with the analysts to bring real GeoJSON data points into the prototype, so it was functionally close to build rather than a visual approximation. Sharing a live, data-accurate map got faster sign-off on style decisions and surfaced missing data points early, before they became build-stage problems.
            </p>

            <div className="mt-8 flex items-stretch gap-4" data-id="element-102" data-mp="35srux9lphtxg">
              {comparison.map((item, i) => <React.Fragment key={item.label} data-id="element-103" data-mp="3jjwphxa7vw0x" data-mpi={i}>
                  <div className={`flex-1 rounded-xl border p-5 ${i === 1 ? 'border-green/30 bg-green-soft' : 'border-line bg-mist'}`} data-id="element-104" data-mp="3elv435pbjkma">
                    <p className={`font-sans text-[11px] font-semibold uppercase tracking-[0.18em] ${i === 1 ? 'text-green-deep' : 'text-ink-faint'}`} data-id="element-105" data-mp="3ticbjlue0f3k">
                      {item.label}
                    </p>
                    <p className="mt-3 font-display text-[17px] font-semibold leading-tight text-navy" data-id="element-106" data-mp="3vok4w6gqpekl">
                      {item.value}
                    </p>
                    <p className="mt-2 font-sans text-[13px] text-ink-muted" data-id="element-107" data-mp="9gar77g6uzaj">{item.detail}</p>
                  </div>
                  {i === 0 ? <div className="flex items-center" data-id="element-108" data-mp="e7ssxxq1d3wk">
                      <ArrowRightIcon className="h-5 w-5 text-green" aria-hidden="true" data-id="element-109" data-mp="j5ucskvad793" />
                    </div> : null}
                </React.Fragment>)}
            </div>
          </Panel>
        </div>
      </div>
    </Section>;
}